import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38932efe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " De acuerdo con la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD), te informamos que tus datos personales serán tratados de manera confidencial y con las medidas de seguridad apropiadas. ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Tienes derecho a acceder, rectificar y suprimir tus datos, así como otros derechos reconocidos en la normativa vigente. Al continuar utilizando esta aplicación, confirmas que has leído y aceptas nuestra política de protección de datos. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Si no aceptas esta política, no podrás utilizar la aplicación.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Solo tendrás que aceptarlas una vez.", -1))

import { ref, watch } from "vue";
import { aceptarProteccionDatos } from "@/services/UsuariosService";
import { AceptarProteccionDatos } from "@/interfaces/Usuario";
import { useAuth } from "@/composables/useAuth";
import ModalSuccess from "../Commons/ModalSuccess.vue";
import ModalError from "../Commons/ModalError.vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalProteccionDatos',
  emits: ["modalClosed"],
  setup(__props, { emit: __emit }) {

const router = useRouter();

const { logout, getidUsuario } = useAuth();
const idUsuarioLogger = ref<number>(parseInt(getidUsuario.value));

const isVisibleModal = ref<boolean>(true);

const showSuccessModal = ref<boolean>(false);
const showErrorModal = ref<boolean>(false);

const emit = __emit;

const aceptarPolitica = async () => {
  const body: AceptarProteccionDatos = {
    idUsuario: idUsuarioLogger.value,
    proteccionDatos: true,
  };
  try {
    await aceptarProteccionDatos(body);
    isVisibleModal.value = false;
    showSuccessModal.value = true;
  } catch (error) {
    console.error(error);
    isVisibleModal.value = false;
    showSuccessModal.value = true;
  }
};

const cancelarPolitica = async () => {
  logout();
  router.push({ name: "inicio-sesion" });
};

// Método que maneja el cierre del modal de éxito
watch(showSuccessModal, (newValue) => {
  if (!newValue) {
    emit("modalClosed");
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: isVisibleModal.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isVisibleModal).value = $event)),
      persistent: "",
      "max-width": "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-h5" }, {
              default: _withCtx(() => [
                _createTextVNode("Protección de Datos")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "text-center" }, {
              default: _withCtx(() => [
                _hoisted_1,
                _hoisted_2,
                _hoisted_3,
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "justify-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "tonal",
                  color: "primary",
                  onClick: aceptarPolitica
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Aceptar ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  variant: "tonal",
                  color: "secondary",
                  onClick: cancelarPolitica
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cancelar ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Gracias por aceptar nuestra política de protección de datos.",
      "onUpdate:isVisible": _cache[1] || (_cache[1] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se ha podido acptar la protección de datos. Contacta con el administrador.",
      "onUpdate:isVisible": _cache[2] || (_cache[2] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"])
  ], 64))
}
}

})